// Shared URL evaluation logic for QR & NFC scans.
// Avoid importing from camera store directly to keep concerns separate.

export interface UrlCheck {
    errorMessage: string | null; // user-facing error if disallowed
    isAllowed: boolean | null; // null when no content
    redirectUrl: string | null;
}

// Extend / adjust prefixes here as environments evolve.
export const allowedPrefixes: readonly string[] = [
    'https://api.renki.app/v1',
    'https://api.staging.renki.co.uk/v1',
    'http://api.localhost/v1',
];

export function checkScannedUrl(content: string | null): UrlCheck {
    if (!content) {
        return { errorMessage: null, isAllowed: null, redirectUrl: null };
    }
    const allow = allowedPrefixes.some((p) => content.startsWith(p));
    if (allow) {
        return { errorMessage: null, isAllowed: true, redirectUrl: content };
    }
    // Unknown URL => treat as disallowed; show generic message
    return { errorMessage: 'This tag is not supported', isAllowed: false, redirectUrl: null };
}
